<template lang="pug">
  v-container(fluid)
    v-card.pa-2.ma-2.mx-0.style(v-if="!isKioskMode")
      v-row(cols="12" no-gutters @click="onDayMenuClick" )
        v-col.text-capitalize(cols="7") {{ offerItem.dayName }}
        v-col.text-right(cols="4") {{ offerItem.displayDate }}
        v-col.text-right(cols="1")
          v-icon.next-icon(color="primary" small) fas fa-chevron-double-right
      v-row.ma-0(no-gutters v-if="!setFreeDay")
        v-col(cols="12" v-for="(menuGroupItem, idx) in offerItem.menuGroupList" :key="idx")
          CalendarGroupKindItem.mt-2(v-if="!isKioskMode"
            :menuGroupItem="menuGroupItem" :offerItem="offerItem" :reservationItem="getReservationItem(menuGroupItem)"
          )
      v-row(no-gutters v-else)
        v-col
          CalendarGroupKindItem( :eventName="getEventName" )
    v-row.pa-0.ma-3.mx-0.style.elevation-0.fill-height(v-else style="height: 5vh" @click="onDayMenuClick" :ripple="false")
      v-row.ma-0
        v-col.pa-0(cols="12")
          v-row.ma-0.fill-height( )
            v-col.text-capitalize.text-h5.pt-2.pa-0.text-start(cols="5" ) {{ offerItem.dayName }}
            v-col.text-h5.pt-2.pa-0.text-start.pl-6(cols="3") {{ offerItem.dateWithoutYear }}
            v-col.text-end.pl-8(cols="2").pb-1.pr-0
              v-icon.next-icon(color="primary" medium) fas fa-chevron-double-right
            v-col.pt-0.pb-10.pa-0(cols="1" v-if="!setFreeDay" )
              CalendarGroupKindItem.mt-2(
                :menuGroupItem="getMemuGroupItem" :offerItem="offerItem" :reservationItem="getReservationItem(getMemuGroupItem)"
              )
            v-col(v-else)
              CalendarGroupKindItem( :eventName="getEventName" )


</template>

<script lang="ts">
import Vue from 'vue'

import DailyMenuOffer from '@/model/DailyMenuOffer'
import CalendarGroupKindItem from '@/components/order/CalendarGroupKindItem.vue'
import MenuReservationItem from '@/model/MenuReservationItem'
import router from '@/router'
import {RawLocation} from 'vue-router/types/router'
import moment from 'moment'
import {Component, Prop} from "vue-property-decorator";
import CalendarEventForDay from "@/model/CalendarEventForDay";
import {GET_CALENDAR_EVENTS, GET_MODE} from "@/store/getter-types";
import {SET_SELECTED_MENU_ITEM} from "@/store/action-types";
import MenuGroupItem from "@/model/MenuGroupItem";
import _ from "lodash";

@Component({
  components: {
    CalendarGroupKindItem
  }
})

export default class CalendarOfferItem extends Vue {

  @Prop({type: Object as () => DailyMenuOffer, required: true}) offerItem!: DailyMenuOffer
  @Prop({type: Date}) date!: Date
  @Prop({type: Array as () => MenuReservationItem[]}) reservationItem!: MenuReservationItem[]

  private setFreeDay: boolean = false
  private events: CalendarEventForDay[] | undefined = undefined

  get getFirstReservationItem (): MenuReservationItem | undefined {
    return _.first(this.reservationItem)
  }

  get getMemuGroupItem (): any {
    let  foundItem: MenuGroupItem | undefined = undefined
    if(this.getFirstReservationItem && this.getFirstReservationItem.topMenuGroup && this.getFirstReservationItem.topMenuGroup.title) {
      foundItem = this.offerItem.menuGroupList.find((item: MenuGroupItem) => this.getFirstReservationItem!.topMenuGroup.title === item.title)
    }
    return foundItem
  }

  get cardClass(): string | undefined {
      let localeIsoWeek = localStorage.getItem('uiLanguageCodeApp') || navigator.language || process.env.VUE_APP_I18N_LOCALE || 'sk'
    if (this.date && this.reservationItem) {
      if (moment(this.offerItem.date).locale(localeIsoWeek).isSame(this.date, 'date')) {
        return 'light-green lighten-3'
      }
    }
    return undefined
  }

  get isKioskMode (): boolean {
    return this.$store.getters[GET_MODE] === 'kiosk'
  }

  get getEventName(): string{
    const foundEvent: CalendarEventForDay | undefined = this.events!.find((item: CalendarEventForDay) => moment(item.date).format('DD.M.YYYY') == moment(this.offerItem.formatedDbDate).format('DD.M.YYYY'))
    if (foundEvent!.kind.name == 'holiday') {
      return 'Prázdniny'
    } else if(foundEvent!.kind.name == 'free_day') {
      return 'Voľný deň'
    } else {
      return ''
    }
  }

  getCurrentEvent(): void {
    if (this.events) {
      const foundEvent: CalendarEventForDay | undefined = this.events.find((item: CalendarEventForDay) => moment(item.date).format('DD.M.YYYY') == moment(this.offerItem.formatedDbDate).format('DD.M.YYYY'))
      this.setFreeDay = !!foundEvent
    }
  }

  getReservationItem (menuGroupItem: MenuGroupItem): MenuReservationItem | null {
    const foundReservationItem: MenuReservationItem | undefined = this.reservationItem.find((item: MenuReservationItem) =>  item.topMenuGroup.id === menuGroupItem.id)
    return foundReservationItem ? foundReservationItem : null
  }

  onDayMenuClick(): void {
    router.push({
      name: 'Order',
      params: {
        isoWeek: this.$route.params.isoWeek,
        date: this.offerItem.formatedDbDate
      }
    } as RawLocation).catch((err: Error) => {
    })
    if(this.getFirstReservationItem) {
      this.$store.dispatch(SET_SELECTED_MENU_ITEM, this.getFirstReservationItem!.topMenuGroup.title)
    } else {
      this.$store.dispatch(SET_SELECTED_MENU_ITEM, 'Denné menu')
    }
  }

  mounted(): void {
    this.events = this.$store.getters[GET_CALENDAR_EVENTS]
    this.getCurrentEvent()
  }

}
</script>

<style lang="stylus" scoped>

.v-card--link:focus
  background: white


.v-card--link:focus::before
  opacity: 0

.style
  cursor: pointer

</style>
